const AUTHORIZATION = 'Basic 6ZcSj9Bf5JNF6MDRrX4';
const END_POINT = 'https://20.ecmascript.pages.academy/big-trip';

const Method = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

const Url = {
  TRIPS: 'points',
  DESTINATIONS: 'destinations',
  OFFERS: 'offers'
};

export {AUTHORIZATION, END_POINT, Method, Url};
